// Generated by CoffeeScript 2.7.0
import BaseModel from './base_model.js';

export var SelectOptionProxy = class SelectOptionProxy {
  constructor(option, value) {
    this.option = option;
    this.value = value;
    this.delegateTo(_.without(this.option.constructor.getAttributeNames(), 'value'), this.option);
  }

};

export var SelectOption = (function() {
  class SelectOption extends BaseModel {};

  SelectOption.setAttributes(['value', 'label', '_status']);

  return SelectOption;

}).call(this);

export default SelectOption;
